module.exports = __webpack_public_path__ + "img/btn-red-bg-b.8189ba5e.png";